import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  searchAllRequests,
  searchAllRequestsCompleted,
} from "../../slices/all_requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleSearchAllRequests({ page, items, filters }) {
  return await workflowsService.listUserRequest(page, items, filters);
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* searchAllRequestsSaga({ payload }) {
  try {
    yield put(searchAllRequests({ term: payload.filters }));
    const allRequestsData = yield call(handleSearchAllRequests, payload);
    const usersTokens = allRequestsData.data.map((item) => item.user_token);
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    allRequestsData.data = allRequestsData.data.map((item) => {
      const user = usersData.find((user) => user.token === item.user_token);
      return {
        ...item,
        fullName: `${user.name} ${user.last_name}`,
      };
    });

    yield put(searchAllRequestsCompleted(allRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* searchAllRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_SEARCH_LIST_ALL_REQUESTS,
    searchAllRequestsSaga
  );
}
